// src/locale/localeOnly.ts
var getLocaleOnly = (lang) => {
  var _a;
  if (!lang) return "en";
  return ((_a = lang == null ? void 0 : lang.split("-")) == null ? void 0 : _a[0]) || "en";
};

export {
  getLocaleOnly
};
//# sourceMappingURL=chunk-LG2WHHGF.mjs.map